import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { Credentials } from "auth";
import { State } from "redux/state";

export const ACCEPT_INVITE: AcceptInvite = "ACCEPT_INVITE";
export type AcceptInvite = "ACCEPT_INVITE";
export const ACCEPT_INVITE_END: AcceptInviteEnd = "ACCEPT_INVITE_END";
export type AcceptInviteEnd = "ACCEPT_INVITE_END";

export interface AcceptInviteAction extends Action {
    payload: {
        inviteId: string;
        redirectOnSuccess?: string;
        credentials: Credentials;
    };
    type: AcceptInvite;
}

export function acceptInvite(
    inviteId: string,
    redirectOnSuccess?: string
): ThunkAction<void, State, undefined, AcceptInviteAction> {
    return (dispatch: Dispatch<AcceptInviteAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(acceptInviteWithCreds(credentials, inviteId, redirectOnSuccess));
    };
}

function acceptInviteWithCreds(
    credentials: Credentials,
    inviteId: string,
    redirectOnSuccess?: string
): AcceptInviteAction {
    return {
        payload: {
            credentials,
            inviteId,
            redirectOnSuccess
        },
        type: ACCEPT_INVITE
    };
}

export interface AcceptInviteEndAction extends Action {
    payload: {
        error?: Error;
    };
    type: AcceptInviteEnd;
}

export function acceptInviteEnd(error?: Error): AcceptInviteEndAction {
    return {
        payload: {
            error
        },
        type: ACCEPT_INVITE_END
    };
}
